import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { createReportApi } from "../../api-helpers/ReportsApiHelper";
import { ReportsLinks } from "reports-experience-client";
import { useWindowHeight } from "../../customHooks/useWindowHeight";

const Reports = () => {
  const [reports, setReports] = useState<ReportsLinks[]>([]);
  const [selectedReport, setSelectedReport] = useState<string>('');
  const [selectedReportName, setSelectedReportName] = useState<string>('');

  const reportsApi = createReportApi();

  const parentDivRef = useRef<HTMLDivElement>(null);
  const windowHeight = useWindowHeight(parentDivRef);

  useEffect(() => {
    getAllReports();
  }, []);

  const getAllReports = async () => {
    try {
      const reports = await reportsApi.reportsControllerGetAllReports();
      setReports(reports.data);
    } catch (error) {
      console.error("Failed to fetch reports:", error);
    }
  };

  const handleReportChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedUrl = event.target.value;
    setSelectedReport(selectedUrl);

    const selectedReport = reports.find(report => report.url === selectedUrl);
    if (selectedReport) {
      setSelectedReportName(selectedReport.name);
    }
  };

  return (
    <>
      <div
        className="d-flex align-items-center px-5 py-2 border-bottom"
        aria-label="breadcrumb"
      >
        <div className="flex-fill d-flex align-items-center">
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item breadcrumb-item-first">
                <Link to="/home">
                  <span className="material-symbols-outlined fs-14">home</span>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {'Reports'}
              </li>
            </ol>
            <h1 className="h3 m-0">{'Reports'}</h1>
          </div>
        </div>
      </div>

      <div className="d-flex px-5 d-flex align-items-stretch">
        <div className="flex-fill">
          <div className="py-3">
            <div className="d-flex justify-content-start mb-4">
              <select
                className="form-select w-auto"
                value={selectedReport}
                onChange={handleReportChange}
              >
                <option value="" disabled>Select a Report</option>
                {reports.map((reportLink, index) => (
                  <option key={index} value={reportLink.url}>
                    {reportLink.name}
                  </option>
                ))}
              </select>
            </div>
            <div ref={parentDivRef}>
              {selectedReport && (
                <iframe
                  src={selectedReport}
                  title={selectedReportName || ''}
                  width="100%"
                  height={windowHeight}
                  style={{ border: 'none' }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;